var _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 28",
    role: "img",
    "aria-label": "HubSpot",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7A59",
    cx: 14,
    cy: 14,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 8.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 8.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 19,
    fill: "#33475B",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "HubSpot")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.68d1619560177ab421bdde9f69b473dc.svg";
export { ForwardRef as ReactComponent };